<template>
  <div class="component-product-select">
		<div class="is-required b-form-group form-group">
			<label for="ccmonth" class="col-form-label">Продукты</label>
			<div class="field-body">
				<select class="custom-select" v-model="form.type" @change="typeChangeHandler" :disabled="disabled">
					<option value="" disabled="disabled">-- выберите категорию --</option>
					<option v-for="(type, key) in types" :label="type.name" :value="type.id" :key="key"></option>
				</select>

				<select class="custom-select" v-if="products.length > 0" v-model="form.product" @change="productChangeHandler" :disabled="disabled">
					<option value="" disabled="disabled">-- выберите продукт --</option>
					<option v-for="(product, key) in products" :label="product.title" :value="product.id" :key="key"></option>
				</select>
			</div>
		</div>
  </div>
</template>

<script>
import product from '@/api/modules/product/product'
export default {
	data: function () {
		return {
			types: [],
			products: [],
			form: {
				type: '',
				product: ''
			}
		}
	},
	props: {
		type: {
			type: Number,
			default: 0
		},
		product: {
			type: Number,
			default: 0
		},
		disabled: {
			type: Boolean,
			default: false
		}
	},
	mounted: function () {
		this.form.type = this.type
		this.form.product = this.product
		product.getAllProductTypes().then((result) => {
			if (result.length === 0) return false
			for (let key in result) {
				if (result[key].parent_id === 0) {
					this.types.push(result[key])
				}
			}
			if (this.type === 0) this.form.type = ''
		})
		if (this.type > 0) {
			this.fillProducts()
		}
	},
	methods: {
		typeChangeHandler () {
			if (this.form.type < 1) return false

			this.form.product = ''
			this.products = []
			this.fillProducts()
		},
		productChangeHandler () {
			this.$emit('changeProduct', this.form.product)
		},
		fillProducts () {
			product.getProductsByTypeId(this.form.type).then((result) => {
				this.products = result
			})
		}
	}
}
</script>

<style>
.component-product-select .el-form-item:first-child {
	margin-bottom: 5px
}

.component-product-select .el-form-item__error {
	display: none !important;
}
.component-product-select select {
	margin-bottom: 0.5rem;
}

.component-product-select select:last-child {
	margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/product/ProductSelect.vue